module.exports = __webpack_public_path__ + "components/login/static/background-0e4b35eb5441435c2d7c68a65cd168af.jpg";